<i18n>
{
  "en": {
    "previewQRs": "See QR Codes.",
    "noPreviewQRs": "No QRs available to preview.",
    "downloadQRs": "Download QR Codes.",
    "noDownloadQRs": "No QRs available to download."
  },
  "es": {
    "previewQRs": "Visualizar códigos QR.",
    "downloadQRs":  "Descargar códigos QR.",
    "noPreviewQRs": "No hay QRs disponibles para visualizar",
    "noDownloadQRs": "No hay QRs disponibles para descargar"
  }
}
</i18n>

<template>
  <dynameat-row :title="saleZone.name" :buttonConfigList="buttonConfigList" :isClickable="false"
                @preview-qrcode="onPreviewQRCode" @download-qrcode="onDownloadQRCode"/>
</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Components } from '@core/helpers/decorators';
import { SaleZone } from '@dynameat/views/pointOfSale/models';
import DynameatRow from '@dynameat/components/DynameatRow';

@Component
@Components({ DynameatRow })
export default class MasterSaleZoneRow extends Vue {
    @Prop({ Object, validator(saleZone) { return saleZone instanceof SaleZone; } }) saleZone;

    get buttonConfigList() {
      return [
        {
          title: `${this.$t('previewQRs')}`,
          icon: 'mdi-qrcode-scan',
          emitName: (!this.isDisabledQRs) ? 'preview-qrcode' : 'no-event',
          disabled: this.isDisabledQRs
        },
        {
          title: `${this.$t('downloadQRs')}`,
          icon: 'mdi-download',
          emitName: (!this.isDisabledQRs) ? 'download-qrcode' : 'no-event',
          disabled: this.isDisabledQRs
        }
      ];
    }

    get isDisabledQRs() {
      const areSaleLocationQRs = this.saleZone.saleLocations.some((saleLocation) => !!saleLocation.qrCode);
      return !(!!this.saleZone.qrCode || areSaleLocationQRs);
    }

    onPreviewQRCode() {
      this.$emit('preview-qrcode', this.saleZone);
    }

    onDownloadQRCode() {
      this.$emit('download-qrcode', this.saleZone);
    }
}
</script>

<style scoped lang="scss">
.chip-top {
  margin-top: 5px;
  margin-left: 0;
}

.chip {
  margin-top: 5px;
  margin-right: 5px;
}

.v-list-item__action--stack {
  align-items: center;
}

.v-list-item__action--stack > .v-icon.v-icon {
  font-size: large;
}

</style>
